import { CreativeConfig } from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';

export function usePropsSwitchDisabled(options: { creativeConfig: Ref<CreativeConfig> }) {
  const { creativeConfig } = options;
  const disabled = computed(() => creativeConfig.value.disableDlp);
  return {
    disabled,
  };
}
